"use client";
import Navigation from "@/HomeFeatures/Navigation";

export default function SchedulePage() {
  return (
    <>
      <style jsx global>{`
        @keyframes soft-jump {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        @keyframes glow-pulse {
          0%,
          100% {
            filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.3));
          }
          50% {
            filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.4));
          }
        }
        .animate-jump {
          animation:
            soft-jump 2s infinite ease-in-out,
            glow-pulse 2s infinite ease-in-out;
        }
        .animate-jump:hover {
          animation-play-state: paused;
        }
      `}</style>

      <section className="relative w-full min-h-screen overflow-hidden flex flex-col">
        {/* Gradient background */}
        <div className="absolute inset-0 bg-gradient-to-r from-black via-[#020617] to-[#0a1f44] z-[1]" />

        {/* Content */}
        <div className="relative z-10 w-full flex flex-col flex-1">
          <Navigation />

          {/* Heading */}
          <div className="text-center pt-10 pb-4">
            <h1 className="text-white text-4xl md:text-5xl font-medium clash-font tracking-tight">
              Schedule A Meeting
            </h1>
          </div>

          {/* Calendly iframe */}
           <div className="flex items-center justify-center py-12 px-5 md:px-1">
          <div className="relative bg-white w-full max-w-[1000px] rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
            <iframe
              src="https://calendly.com/connect-konstantinfo/60min?embed_domain=konstantinfo.com"
              width="100%"
              height="100%"
              style={{ minHeight: "80vh" }}
              frameBorder="0"
              allow="payment"
              scrolling="yes"
              title="Schedule time with us"
            ></iframe>
          </div>
          </div>
        </div>
      </section>
    </>
  );
}